import { useTranslation } from "react-i18next";
import { LeafModal } from "../../../../../common/leaf/LeafModal/LeafModal";
import defaultContent from "../../../../../content/rubyBonusModal";
import { getCountryNameFromCode } from "../../../../../common/util/formatCountryName";
import { storedLocale } from "../../../../Authentication/util";
import "./RubyBonusModal.scss";

interface CountryVolume {
  actual: number;
  formatted: string;
}

interface RubyBonusModalProps {
  open: boolean;
  onClose: () => void;
  rubyBV: string;
  isEarning: boolean;
  bonusTotal: string;
  rubyMultiplier?: string;
  rubyBVByCountry?: Record<string, CountryVolume>;
}

export const RubyBonusModal = ({
  open,
  onClose,
  rubyBV,
  isEarning,
  bonusTotal,
  rubyMultiplier,
  rubyBVByCountry,
}: RubyBonusModalProps) => {
  const { t } = useTranslation(["rubyBonusModal"]);
  const locale = storedLocale();

  const countryEntries =
    rubyBVByCountry && Object.keys(rubyBVByCountry).length > 1 ? Object.entries(rubyBVByCountry) : [];

  return (
    <LeafModal
      open={open}
      onCloseCallbackFn={onClose}
      title={t("title", defaultContent.title).toString()}
      description={t("description", defaultContent.description).toString()}
      id="RubyBonusModal"
    >
      <div className="RubyBonusModal__content">
        <hr className="RubyBonusModal__divider" />
        <div className="RubyBonusModal__row">
          <span className="RubyBonusModal__label">{t("rubyBV", defaultContent.rubyBV).toString()}</span>
          <span className="RubyBonusModal__value">{rubyBV}</span>
        </div>

        {countryEntries.length > 0 && (
          <div className="RubyBonusModal__country-breakdown">
            {countryEntries.map(([countryCode, bv]) => {
              const countryName = getCountryNameFromCode(countryCode, locale) ?? countryCode;
              return (
                <div key={countryCode} className="RubyBonusModal__country-row">
                  <span className="RubyBonusModal__country-label">{countryName}</span>
                  <div className="RubyBonusModal__country-values">
                    <span className="RubyBonusModal__country-value">{bv.formatted}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="RubyBonusModal__row">
          <span className="RubyBonusModal__label">{t("rubyMultiplier", defaultContent.rubyMultiplier).toString()}</span>
          <span className="RubyBonusModal__value">x {rubyMultiplier || "2%"}</span>
        </div>

        <hr className="RubyBonusModal__divider" />

        <div className="RubyBonusModal__row RubyBonusModal__row--total">
          <span className="RubyBonusModal__label RubyBonusModal__label--bold">
            {t("rubyBonusTotal", defaultContent.rubyBonusTotal).toString()}
          </span>
          <span className="RubyBonusModal__value RubyBonusModal__value--bold">
            {isEarning ? bonusTotal : t("notAvailable", defaultContent.notAvailable).toString()}
          </span>
        </div>
      </div>
    </LeafModal>
  );
};
